<template>
    <q-btn flat dense round icon="far fa-bell" class="q-mr-sm">
        <q-chip floating icon-right color="red" v-if="getMessagesLength > 0">{{ getMessagesLength }}</q-chip>

        <q-popover :style="{ minWidth: '200px' }">
            <q-list link separator>
                <q-item v-for="(message, index) in filteredMessages" :key="index" @click.native="checkMessage(message)" v-close-overlay>
                    <q-item-side>
                        <q-icon :name="`far fa-${getIconNotification(message.mt)}`" size="1.5rem" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label>{{ message.t }}</q-item-tile>
                    </q-item-main>
                </q-item>

                <q-item v-if="getMessagesLength === 0">
                    <q-item-side>
                        <q-icon name="fas fa-ban" size="1.5rem" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label>{{ $t('no_notification_avaliable') }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>
        </q-popover>

        <q-modal v-model="show_message" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_message = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('message') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <span v-html="selected_message.b" style="max-width: 100%;"></span>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="fas fa-times" @click="show_message = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('mark_as_read')" icon="fas fa-check" @click="markAsRead(index)" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_modal_badge" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_modal_badge = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ badge.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-3 badge">
                            <img :src="getBadgeImage(badge)" :class="getBadgeClass(badge)" />
                        </div>
                        <div class="col-xs-12 col-sm-9">
                            <div class="q-display-1 q-mb-md">{{ badge.title }}</div>
                            <p>{{ badge.description }}</p>
                            <p v-if="badge.earned_date">{{ $t('earned_in') }}: {{ formatDate(badge.earned_date) }}</p>
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <modal-stars :show="show_modal_star" :course="course" @hideModal="hideModal" :read_only="true" />

        <modal-notification :show_modal="show_news" :id="id_news" @hideModalNews="hideModalNews" />
    </q-btn>
</template>

<script>
import { mapGetters } from 'vuex'
import { db } from 'plugins/vuefire'
import ModalStars from 'components/courses/ModalStars'
import ModalNews from 'components/News'
import { date } from 'quasar'
const { formatDate } = date

export default {
    i18nOptions: { namespaces: [ "custom", 'common'] },

    data() {
        return {
            messages: [],
            query: [],
            selected_message: [],
            show_message: false,
            index: '',
            show_popover: false,
            show_modal_star: false,
            course: {},
            badge: {
                title: '',
                description: '',
                earned_date: '',
                badge_images: []
            },
            show_modal_badge: false,
            show_news:false,
            id_news: ''
        }
    },

    components: {
        'modal-stars': ModalStars,
        'modal-notification': ModalNews,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id: 'common/id',
            id_user_client_profile: 'common/id_user_client_profile',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMessagesLength() {
            if (this.filteredMessages) return this.filteredMessages.length
            else return 0
        },

        filteredMessages() {
            if (this.messages && this.messages.m) {
                return this.messages.m.filter(obj => obj.s != 'empty').reverse()
            }
            else {
                return []
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        checkMessage(message) {
            this.show_popover = false
            this.index = this.messages.m.findIndex(x => x.i === message.i)

            if (message.mt === 'm') {
                this.selected_message = message

                this.$q.loading.show()

                this.$axios.get(`/etraining_messages/messages/${message.i}/`, this.getHeader)
                .then(response => {
                    this.selected_message.b = response.data.body
                    this.show_message = true
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
            else if (message.mt === 'gts') {
                this.$q.loading.show()

                this.loadStarInfo(message.i)
                this.show_popover = false
                this.markAsRead(this.index)
            }
            else if(message.mt === 'b') {
                this.loadBadgeInfo(message.i)
                this.show_popover = false
                this.markAsRead(this.index)
            }
            else if(message.mt === 'rgt') {
                this.markAsRead(this.index)
                this.$q.loading.show()
                this.$router.push({ name: 'course', params: { id: message.i} })
            }
            else if(message.mt === 'rt') {
                this.markAsRead(this.index)
                this.$q.loading.show()
                this.$router.push({ name: 'trail', params: { id: message.i} })
            }
            else if(message.mt === 'pui') {
               this.markAsRead(this.index)
               this.$q.loading.show()
               this.$router.push({ name: 'presential_notification', params: { id: message.i} })
            }
            else if (message.mt === 'lci') {
                this.markAsRead(this.index)
                this.$q.loading.show()
                this.$router.push({ name: 'live_classes' })
            }
            else if(message.mt === 'np') {
                this.markAsRead(this.index)
                this.id_news = message.i
                this.show_news = true
            }
            else if (message.mt === 'ur') {
                this.markAsRead(this.index)
                this.$q.loading.show()
                this.$router.push({ name: 'admin_user', params: { id: message.i} })
            }
            else {
                this.show_popover = false
                this.markAsRead(this.index)
            }
        },

        markAsRead(message_index) {
            this.show_message = false

            let fd = new FormData()
            fd.append('message_index', this.index)

            this.$axios.post('/notifications/notifications/read_notification/', fd, this.getHeader)
            .then(response => {

            })
            .catch(e => {
                console.log(e)
            })
        },

        loadStarInfo(id) {
            this.$axios.get(`/etraining_courses/group_trainings/${id}/`, this.getHeader)
            .then(response => {
                this.course = {
                    title: response.data.title,
                    id: response.data.id,
                    user_progress: response.data.user_progress
                }

                this.$q.loading.hide()
                this.show_modal_star = true
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        loadBadgeInfo(id) {
            this.$q.loading.show()

            this.$axios.get(`/etraining_badges/badges/${id}/`, this.getHeader)
            .then(response => {
                this.badge = response.data
                let descriptions  = this.badge.badge_languages

                if(descriptions.length > 0) {
                    descriptions.map(e => {
                        if(e.language == this.id_user_language_selected){
                            this.badge.description = e.description
                            this.badge.title = e.title
                        }
                    })

                    if(!this.badge.description && !this.badge.title) {
                        this.badge.description = descriptions[0].description
                        this.badge.title = descriptions[0].title
                    }
                }
                this.show_modal_badge = true
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        hideModal() {
            this.show_modal_star = false
            this.course = {}
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getBadgeImage(badge) {
            if (badge.badge_images.length > 0) {
                let obj = badge.badge_images.find((obj) => { return obj.image_name === '250x250' })
                if (obj) return obj.image
            }
            return ''
        },

        getBadgeClass(badge) {
            if (!badge.earned_date) return 'disable-badge'
        },

        formatDate(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
        },

        getIconNotification(e) {
            switch(e) {
                case 'rgt':
                    return 'exclamation'
                break
                case 'b':
                    return 'medal'
                break
                case 'm':
                    return 'envelope-square'
                break
                case 'rt':
                    return 'exclamation'
                break
                case 'pui':
                    return 'exclamation'
                break
                case 'np':
                    return 'newspaper'
                break
                case 'gst':
                    return 'stars'
                break;
                case 'ur':
                    return 'user'
                break;
                default:
                    return 'envelope-square'
                break        }

        },

        hideModalNews() {
            this.show_news = false
        }
    },

    watch: {
        query: {
            handler: function(newValue) {
                if (this.query.message_id) {
                    setTimeout(() =>{
                        let obj = this.filteredMessages.find((obj) => { return obj.i == this.query.message_id })
                        if (obj) this.checkMessage(obj)
                    }, 500)
                }
            },
            deep: true
        }
    },

    created() {
        this.$bind('messages', db.collection('notifications').doc(`${this.id}`)).then(messages => {
            this.messages === messages

            this.query = this.$route.query ? this.$route.query : this.query
            this.$router.replace({'query': null})
        })

        // if (this.$q.platform.is.cordova) {
        //     window.plugins.OneSignal
        //     .startInit(process.env.ONE_SIGNAL_ID)
        //     .endInit()

        //     window.plugins.OneSignal
        //     .handleNotificationOpened((jsonData) => {
        //         this.query = jsonData.notification.payload.additionalData
        //         // redirecionar conforme tipo e id passado
        //     })
        //     .inFocusDisplaying(window.plugins.OneSignal.OSInFocusDisplayOption.Notification)
        // }
    },
}
</script>

<style>

</style>
